<template>
    <AuthLayout class="music-library-frame-layout">
        <FullscreenLoading v-if="isLoading" />

        <div class="mb-3 mt-3 d-flex align-items-center">
            <h3 class="mb-0">{{ $t('designer.email_templates') }}</h3>

            <div class="ml-auto text-right">
                <router-link tag="button" class="btn btn-secondary btn-xs ml-3" :to="{ name: 'ceremonies' }">
                    <icon name="arrow-left" class="mr-1"></icon>
                    {{ $t('general.back') }}
                </router-link>
            </div>
        </div>

        <FullscreenIframe v-if="!errorMessage" :src="designerUrl + '/email-templates?locale=' + store.state.currentLocale + '&embed=true&token=' + token" @loading="isLoading = $event" />

        <div class="p-1" v-if="errorMessage">
            <div class="alert alert-danger">
                {{ errorMessage }}
            </div>
        </div>
    </AuthLayout>
</template>

<script setup>
    import AuthLayout from './AuthLayout.vue';
    import { computed, onMounted, ref } from 'vue';
    import { IpcCall, ipcCall } from '../utils/ipcCall';
    import FullscreenIframe from './FullscreenIframe.vue';
    import i18n from '../../utils/locale';
    import store from '../../store/store';
    import FullscreenLoading from '../../components/FullscreenLoading.vue';

    const isLoading = ref(false);
    const token = ref(null);
    const errorMessage = ref(null);

    const designerUrl = computed(() => window.designerUrl);

    onMounted(async () => {
        isLoading.value = true;
        errorMessage.value = null;

        try {
            const isOnline = await ipcCall(IpcCall.CheckIfOnline);

            if (!isOnline) {
                errorMessage.value = i18n.t('designer.email_templates_offline_error');
                isLoading.value = false;

                return;
            }

            token.value = await ipcCall(IpcCall.GetCurrentUserToken);

            // The loading will be removed by the iframe
        } catch (exception) {
            console.error(exception);
            isLoading.value = false;
        }
    });
</script>
